import React, { useEffect, useState } from "react";
import { Button, HStack, useStatStyles } from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
const Header = () => {
  const [selectedTab, setSelectedTab] = useState("home");
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/") {
      setSelectedTab("home");
    } else if (location.pathname === "/exchanges") {
      setSelectedTab("exchanges");
    } else if (location.pathname === "/coins") {
      setSelectedTab("coins");
    }
  }, [setSelectedTab]);

  const handleSelectedTab = (tab) => {
    setSelectedTab(tab);
  };
  return (
    <HStack p={"20"} shadow={"base"} bgColor={"black"}>
      <Button
        onClick={() => handleSelectedTab("home")}
        variant={"unstyled"}
        color={selectedTab === "home" ? " #FCE487" : "white"}
      >
        <Link to="/">Home</Link>
      </Button>
      <Button
        onClick={() => handleSelectedTab("exchanges")}
        variant={"unstyled"}
        color={selectedTab === "exchanges" ? " #FCE487" : "white"}
      >
        <Link to="/exchanges">Exchanges</Link>
      </Button>
      <Button
        onClick={() => handleSelectedTab("coins")}
        variant={"unstyled"}
        color={selectedTab === "coins" ? " #FCE487" : "white"}
      >
        <Link to="/coins">Coins</Link>
      </Button>
    </HStack>
  );
};

export default Header;
